import { render, staticRenderFns } from "./_SettingsWrapper.vue?vue&type=template&id=5985c17f&scoped=true&"
import script from "./_SettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./_SettingsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985c17f",
  null
  
)

export default component.exports